module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header-wrapper"
  }, [_c('i', {
    staticClass: "el-icon-back",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "detail-type",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.detailInfo.created_by) ? _c('div', {
    class: ['fixed-title', {
      'is-show': _vm.isShowTitle
    }]
  }, [_c('el-popover', {
    attrs: {
      "popper-class": "user-card",
      "placement": "top",
      "open-delay": 500,
      "width": "400",
      "trigger": "hover"
    },
    on: {
      "show": function($event) {
        _vm.$refs['card' + _vm.detailInfo.created_by.id].getUserInfo()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0, padding: 0"
    }
  }, [_c('user-card', {
    ref: ("card" + (_vm.detailInfo.created_by.id)),
    attrs: {
      "user-id": _vm.detailInfo.created_by.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-avatar",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    },
    slot: "reference"
  }, [_c('div', {
    staticClass: "user-info-left",
    on: {
      "click": function($event) {
        return _vm.$emit('toPersonal')
      }
    }
  }, [(_vm.detailInfo.created_by.user_logo.substr(0, 1) == '?') ? _c('img', {
    staticClass: "identity-icon",
    attrs: {
      "width": "32",
      "height": "32",
      "src": require("../../images/personal_center/avatar_default.png")
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.detailInfo.created_by.user_logo,
      "alt": "",
      "width": "32",
      "height": "32"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.detailInfo.created_by.nick_name))]), _vm._v(" "), (_vm.detailInfo.created_by.is_official) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "蓝鲸智云官方",
      "placement": "right"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-lanjingguanfang"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.detailInfo.created_by.is_vip) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "核心用户",
      "placement": "right"
    }
  }, [_c('span', {
    staticClass: "icon-vipuser"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "question-title"
  }, [_vm._v(_vm._s(_vm.detailInfo.title))]), _vm._v(" "), (!_vm.isPreview && _vm.isEditor) ? [_c('span', {
    staticClass: "editor-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('editQuestion')
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('span', {
    staticClass: "delete-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('deletePop')
      }
    }
  }, [_vm._v("删除")])] : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5268cd95!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/detailTitle.vue
// module id = hoEl
// module chunks = 16